import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios";
import spinnerInterceptor from "../interceptors/spinner.interceptor";
import authTokenInterceptor from "../interceptors/auth-token-iw.interceptor";
import { LocalLoginRequest, LocalRegisterRequest } from "@appetize/iw-common/interfaces/auth/auth";

const http: AxiosInstance = axios.create({
  baseURL: window.location.origin,
  headers: {
    "Content-Type": "application/json"
  }
});

authTokenInterceptor.wrapAxios(http);
spinnerInterceptor.wrapAxios(http);

const authInit = (venueId: string, showSpinner = true, applyToken = false): Promise<AxiosResponse> => {
  return http.post(`/auth/init`, {}, {
    params: { venue_id: venueId },
    showSpinner,
    applyToken
  } as AxiosRequestConfig);
};

const authGuest = (showSpinner = true, applyToken = true): Promise<AxiosResponse> => {
  return http.post(`/auth/guest`, {}, {
    showSpinner,
    applyToken
  } as AxiosRequestConfig);
};

const loginUser = (body: LocalLoginRequest, showSpinner = true, applyToken = true): Promise<AxiosResponse<string>> => {
  return http.post(`/auth/login`, { ...body }, {
    showSpinner,
    applyToken
  } as AxiosRequestConfig);
};

const authRegister = (userData: LocalRegisterRequest, showSpinner = true, applyToken = true): Promise<AxiosResponse> => {
  return http.post(`/auth/register`, userData, {
    showSpinner,
    applyToken
  } as AxiosRequestConfig);
};

const refreshIWToken = (): Promise<AxiosResponse> => {
  return http.post(`/auth/refresh`, {}, {
    showSpinner: false,
    applyRefreshToken: true
  } as AxiosRequestConfig);
};
export default {
  authInit,
  authGuest,
  loginUser,
  authRegister,
  refreshIWToken
};
